/**
 * Page that, when visited, updates the session and routes user back to root.
 */
import React from 'react';
import PropTypes from 'prop-types';

import LoadingPlaceholder from '../LoadingPlaceholder/LoadingPlaceholder';

const propTypes = {
  updateSessionHandler: PropTypes.func.isRequired,
};

const defaultProps = {};

export default class UpdateSessionPage extends React.Component {
  componentDidMount() {
    const { updateSessionHandler } = this.props;
    updateSessionHandler('/');
  }

  render() {
    return <LoadingPlaceholder />;
  }
}

UpdateSessionPage.propTypes = propTypes;
UpdateSessionPage.defaultProps = defaultProps;
